﻿import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"
import NullableTextObservable from "../observables/nullabletextobservable" 
import ko from 'knockout';
import $ from 'jquery';

export class TextInputBinder implements IBinder {
  public getElements(parent: JQuery): JQuery {
    return parent.find(":input[type='text']");
  }

  public getBinding(element: JQuery): ICellBinding {
    var inputName = element.attr("name");

    return {
      dataName: inputName,
      dataValue: new NullableTextObservable(element.val()),
      bindingName: "init, valueUpdate: 'change.rustig', value",
      bindTo: inputName,
      createEmptyValue: () => {
        return new NullableTextObservable();
      }
    }
  }
}